import { Drawer, DrawerProps } from 'antd'

export const AppDrawer = ({ children, ...rest }: DrawerProps) => {
  return (
    <Drawer
      focusable={{
        focusTriggerAfterClose: false,
        trap: false,
      }}
      {...rest}
    >
      {children}
    </Drawer>
  )
}
